
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[category]/[uid]",
      function () {
        return require("private-next-pages/blog/[category]/[uid].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[category]/[uid]"])
      });
    }
  